export const FOLDER_CREATED = 'folder_created';

export class PublishedVersion {
    name: string;
    publishedDate: string;
}

export class VersionChanges {
    approval?: { approved: string[]; rejected: { reason: string; by: string }[] };
    channels?: UpdatedChanges;
    mimics?: ChangesObject;
    channelGroups?: UpdatedChanges;
    categories?: UpdatedChanges;
    channelOverview: ChannelOverview[];
    numberOps?: { old: number; new: number };
    numberFcu?: { old: number; new: number };
    editors: string[];
    owner: string;
}

export enum ChangesObjectType {
    UNDEFINED = 'undefined',
    UPDATED = 'updated',
    ADDED = 'added',
    DELETED = 'deleted',
}

export class ChangesObject {
    updated: UpdatedChanges;
    added: AddedChanges[];
    deleted: AddedChanges[];
}

export class ChannelOverview {
    name: string;
    status: ChangeStatus;
    groups: {
        name: string;
        status: ChangeStatus;
        channels: { status: ChangeStatus; name: string }[];
    }[];
}

export class AddedChanges {
    parentId: string;
    name: string;
    id: string;
}

export class DeletedChanges {
    parentId: string;
    name: string;
    id: string;
}

export class UpdatedChanges {
    [name: string]: {
        changes: {
            change: string;
            old: string | number;
            new: string | number;
        }[];
        group?: string;
        category?: string;
    };
}

export enum ChangeStatus {
    UNDEFINED = 'undefined',
    ADDED = 'added',
    DELETED = 'deleted',
    UNEDITED = 'unedited',
}
